import styled from "styled-components";

export const DisabledInput = styled.div`
  background-color: #ede7ff;
  border-radius: 7px;
  padding: 1.4rem;
`;

export const SecondaryBtn = styled.button`
  border: 1px solid #231a3d;
  padding: 14px 24px;
  color: #231a3d;
  background-color: transparent;
  border-radius: 7px;
  cursor: pointer;
  font-size: 16px;
  font-family: "Inter";
  font-weight: 500;
`;

export const PhoneInputWrapper = styled.div`
  position: relative;
  /* margin: 8rem 0rem 12rem 0rem; */
  width: 500px;
  & > p {
    color: #4a4a4a;
    position: absolute;
    left: 2rem;
    z-index: 99;
    top: 50%;
    margin-top: 0.1rem;
    transform: translateY(-50%);
    font-size: 16px;
    font-weight: 600;
    pointer-events: none;
    user-select: none;
  }
  & > div {
    width: 1px;
    height: 40%;
    margin-top: 0.1rem;
    background-color: #4a4a4a;
    z-index: 999;
    position: absolute;
    left: 6rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    user-select: none;
  }
`;

export const PhoneInput = styled.input`
  width: 100%;
  background-color: transparent;
  padding: 1.6rem 2rem 1.6rem 2rem;
  outline: none;
  font-weight: 600;
  border: none;
  border: 1px solid #231A3D;
  border-radius: 10px;
  font-size: 16px;
  color: ${(props) => props.theme.accentColor};
  letter-spacing: 2px;
`;

export const Error = styled.span`
  color: red;
  font-size: 1.4rem;
  z-index: 9;
  position: absolute;
  bottom: -3rem;
  left: 0;
`;